





























































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _ from "lodash";
import { Getter } from "vuex-class";
import moment from "moment";
import ThousandNumberInput from "@/components/forms/inputs/ThousandNumberInput.vue";
import CatalogCompensationRepository from "@/repositories/zero-waste/CatalogCompensationRepository";
import CatalogRepository from "@/repositories/zero-waste/CatalogRepository";
import EventBus from "front-component/EventBus";
import * as Constants from "@/Constants";
import Http, {Data} from "front-component/Http";

const components = {
    ThousandNumberInput,
};

@Component({components})
export default class CatalogCompensationForm extends Vue {
    public operation: any | null = false;
    public relatedPressBudgetOperation: any[] = [];
    public indicators: any = [];
    public armisBudget: number = 0;
    public factorElevenBudget: number = 0;
    public emailAcquisitionBudget: number = 0;
    public affichageBudget: number = 0;
    public amountChanged: boolean = false;
    public optionsCompensationStrategy = Constants.compensationStrategy;
    public pressBudget: number = 0;
    public collapse: string[] = ["1", "2"];
    private show: boolean = false;
    private loading: boolean = false;
    private catalog: any | null = false;
    private catalogImageUrl: string = "";
    @Prop(String) public operationUuid!: string | null;
    @Prop(Boolean) private visible!: boolean;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;

    @Watch("operationUuid")
    private changeOperation() {
        this.relatedPressBudgetOperation = [];
        this.catalogImageUrl = "";
        this.fetchData().then(() => {
            this.fetchDataCampaignsWithSamePressBudget();
            this.getCatalogImg();
        });
    }

    @Watch("ownerUuid")
    private changeOwner() {
        this.fetchData();
    }

    public mounted() {
        if (!this.operationUuid) {
            return;
        }
        this.fetchData().then(() => {
            this.fetchDataCampaignsWithSamePressBudget();
            this.getCatalogImg();
        });
    }

    public isOperationIsValidated(): boolean {
        return !!this.operation.isValidated;
    }

    public isValidationDeadlinePassed(): boolean {
        const validationDL = moment(this.operation.validationDeadline).set("hour", 23).set("minute", 59);
        const currentD = moment();

        return (validationDL < currentD);
    }

    public isBudgetExceedsBudgetMax(budget: number, budgetMax: number): boolean {
        let current = _.invoke(this.$options.filters, "number", budget, 2);
        let max = _.invoke(this.$options.filters, "number", budgetMax, 2);

        current = parseFloat(current.replace(/\s/g, "").replace(",", "."));
        max = parseFloat(max.replace(/\s/g, "").replace(",", "."));
        return (current > max) ? true : false;
    }

    public isValidBudgets(): boolean {
        if (
            this.isBudgetExceedsBudgetMax(this.armisBudget, this.indicators.ARMIS_BUDGET_MAX) ||
            this.isBudgetExceedsBudgetMax(this.factorElevenBudget, this.indicators.FACTOR_ELEVEN_BUDGET_MAX)
        ) {
            return false;
        }
        return true;
    }

    public getWarningMessage(): string {
        let message = "";
        if (this.isValidationDeadlinePassed()) {
            const context = { date: moment(this.operation.validationDeadline).format("DD/MM/YYYY") };
            message = _.invoke(this.$options.filters, "trans", "validationDeadlinePassed", "", "", context);
        }
        if (this.isOperationIsValidated()) {
            const context = {
                date: moment(this.operation.updatedAt).format("DD/MM/YYYY"),
                user: this.operation.updatedBy ? this.operation.updatedBy.displayName : "Siège Carrefour"
            };
            message = _.invoke(this.$options.filters, "trans", "operationAlreadyValidated", "", "", context);
        }
        return message;
    }

    public validateBudget(): void {
        if (this.isValidationDeadlinePassed()) {
            return;
        }

        this.$confirm(_.invoke(this.$options.filters, "trans", "confirmValidationBudget"))
            .then(() => {
                const catalogCompensation = {
                    uuid: this.operationUuid,
                    isValidated: true,
                };

                CatalogCompensationRepository.save(catalogCompensation).then((data: object) => {
                    this.fetchData();
                    EventBus.$emit("catalog-status-updated");
                });
            })
            .catch(() => {
                return;
            })
        ;
    }

    public cancelBudget(): void {

        if (this.isOperationIsValidated() || this.isValidationDeadlinePassed()) {
            return;
        }

        this.$confirm(_.invoke(this.$options.filters, "trans", "confirmCancelBudget"))
            .then(() => {
                const catalogCompensation = {
                    uuid: this.operationUuid,
                    isValidated: false,
                };

                CatalogCompensationRepository.save(catalogCompensation).then((data: object) => {
                    this.fetchData();
                    EventBus.$emit("catalog-status-updated");
                });
            })
            .catch(() => {
                return;
            })
        ;
    }

    public resetArmisBudget(): void {

        if (null === this.operation.armisBudgetRecommended) {
            return;
        }
        this.resetBudget({armisBudget: this.operation.armisBudgetRecommended});
    }

    public resetPressBudget(): void {
        if (null === this.operation.pressBudgetRecommended) {
            return;
        }
        this.resetBudget({pressBudget: this.operation.pressBudgetRecommended});
    }

    public resetFactorElevenBudget(): void {
        if (null === this.operation.factorElevenBudgetRecommended) {
            return;
        }
        this.resetBudget({factorElevenBudget: this.operation.factorElevenBudgetRecommended});
    }

    public resetAffichageBudget(): void {
        if (null === this.operation.affichageBudgetRecommended) {
            return;
        }
        this.resetBudget({affichageBudget: this.operation.affichageBudgetRecommended});
    }

    public resetEmailAcquisitionBudget(): void {
        if (null === this.operation.emailAcquisitionRecommended) {
            return;
        }
        this.resetBudget({emailAcquisitionBudget: this.operation.emailAcquisitionBudgetRecommended});
    }

    public cancelPressBudget(): void {
        this.emptyBudget({pressBudget: 0});
    }

    public cancelArmisBudget(): void {
        this.emptyBudget({armisBudget: 0});
    }

    public cancelFactorElevenBudget(): void {
        this.emptyBudget({factorElevenBudget: 0});
    }

    public cancelAffichageBudget(): void {
        this.emptyBudget({affichageBudget: 0});
    }

    public cancelEmailAcquisitionBudget(): void {
        this.emptyBudget({emailAcquisitionBudget: 0});
    }

    public emptyBudget(budgetToDelete: object): void {
        if (this.isValidationDeadlinePassed()) {
            return;
        }

        this.$confirm(_.invoke(this.$options.filters, "trans", "cancelBudget"))
            .then(() => {
                const catalogCompensation = _.merge({uuid: this.operationUuid}, budgetToDelete);
                CatalogCompensationRepository.save(catalogCompensation).then((data: object) => {
                    this.fetchData();
                });
            })
            .catch(() => {
                return;
            })
        ;
    }

    public resetBudget(budgetRecommended: object): void {

        if (this.isValidationDeadlinePassed()) {
            return;
        }

        this.$confirm(_.invoke(this.$options.filters, "trans", "confirmResetBudget"))
            .then(() => {
                const catalogCompensation = _.merge({uuid: this.operationUuid}, budgetRecommended);
                CatalogCompensationRepository.save(catalogCompensation).then((data: object) => {
                    this.fetchData();
                });
            })
            .catch(() => {
                return;
            })
        ;
    }

    public saveBudget(): void {
        if (this.isValidationDeadlinePassed()) {
            return;
        }

        this.$confirm(_.invoke(this.$options.filters, "trans", "confirmSaveAction"))
            .then(() => {
                const catalogCompensation = {
                    uuid: this.operationUuid,
                    armisBudget: this.armisBudget,
                    factorElevenBudget: this.factorElevenBudget,
                    pressBudget: this.pressBudget,
                    affichageBudget: this.affichageBudget,
                    emailAcquisitionBudget: this.emailAcquisitionBudget,
                };

                CatalogCompensationRepository.save(catalogCompensation).then((data: object) => {
                    this.fetchData();
                    this.$emit("budgets-update");
                });
            })
            .catch(() => {
                return;
            })
        ;
    }

    public updateArmisAmount(amount: number, amountMax: number): void {
        this.amountChanged = true;
        if (!this.hasFeature("CONFIG_SOCLE")) {
            this.updateAmount(amount, amountMax);
        }
        this.armisBudget = amount;
    }

    public updatePressAmount(amount: number): void {
        this.amountChanged = true;
        this.pressBudget = amount;
    }

    public updateAffichageAmount(amount: number): void {
        this.amountChanged = true;
        this.affichageBudget = amount;
    }

    public updateEmailAcquisitionAmount(amount: number): void {
        this.amountChanged = true;
        this.emailAcquisitionBudget = amount;
    }

    public updateFactorElevenAmount(amount: number): void {
        this.amountChanged = true;
        this.factorElevenBudget = amount;
    }

    private get warningAmountChanged(): string {
        if (this.amountChanged) {
            return _.invoke(this.$options.filters, "trans", "warningAmountChanged");
        }
        return "";
    }

    private updateAmount(amount: number, amountMax: number): void {
        if (!amount) {
            return;
        }

        if (this.isBudgetExceedsBudgetMax(amount, amountMax)) {
            this.$message({
                message: _.invoke(this.$options.filters, "trans", "budgetExceedsBudgetMax"),
                type: "error"
            });
        }
    }

    private fetchData() {
        return new Promise((resolve) => {
            if (!this.ownerUuid || !this.operationUuid)  {
                return;
            }
            this.loading = true;
            const params = {
                filters: {
                    uuid: this.operationUuid,
                    detail: true,
                },
            };
            CatalogCompensationRepository.get(params)
                .then((data: object[]) => {
                    this.operation = data[0] as any;
                    this.indicators = _.get(data, "indicators", []);
                    this.armisBudget = this.operation.armisBudget;
                    this.factorElevenBudget = this.operation.factorElevenBudget;
                    this.pressBudget = this.operation.pressBudget;
                    this.emailAcquisitionBudget = this.operation.emailAcquisitionBudget;
                    this.affichageBudget = this.operation.affichageBudget;
                    this.amountChanged = false;
                    this.loading = false;
                    resolve(this.operation);
                });
        });
    }

    public getCatalogImg() {
        if (!this.operation.catalog || !this.operation.catalog.document) {
            return;
        }
        Http.download(
            this.operation.catalog.document.link,
            {},
            (result: ArrayBuffer) => {
                const blob = new Blob([result]);
                this.catalogImageUrl = URL.createObjectURL(blob);
            },
            () => {
                this.$message.error("Error downloading the image.");
            }
        );
    }
    private fetchDataCampaignsWithSamePressBudget() {
        this.loading = true;
        const params = {
            filters: {
                pressBudget: this.pressBudget,
                beginDate: this.operation.startDate,
                endDate: this.operation.endDate,
                hierarchyOwner: this.operation.hierarchyOwner.uuid,
            },
        };
        CatalogCompensationRepository.get(params).then((data: any) => {
            data.forEach((element: any) => {
                if (this.pressBudget > 0 &&
                    element.hierarchyOwner.uuid === this.operation.hierarchyOwner.uuid &&
                    element.pressBudget === this.pressBudget &&
                    element.startDate === this.operation.startDate &&
                    element.endDate === this.operation.endDate &&
                    element.uuid !== this.operation.uuid &&
                    !element.isValidated
                ) {
                    this.relatedPressBudgetOperation.push(element);
                } else {
                    const index = this.relatedPressBudgetOperation.findIndex(
                        (item: any) => item.uuid === element.uuid
                    );
                    if (index !== -1) {
                        this.relatedPressBudgetOperation.splice(index, 1);
                    }
                }
            });
        }).finally(() => {
            this.loading = false;
        });
    }

    public closed() {
        this.$emit("closed");
    }
}

